import { t } from "@lingui/macro";
import { useMutation } from "@tanstack/react-query";
import _axios from "axios";
import { saveAs } from "file-saver";

import { toast } from "@/client/hooks/use-toast";

const rawAxios = _axios.create({ baseURL: "/api", withCredentials: true });

export const generateDocx = async (data: { id: string }) => {
  const response = await rawAxios.get(`/resume/docx/${data.id}`, {
    responseType: "blob",
  });

  const filename = `careerbldr_resume-${data.id}.docx`;

  saveAs(
    new Blob([response.data], {
      type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    }),
    filename,
  );
};

export const useGenerateDocx = () => {
  const {
    error,
    isPending: loading,
    mutateAsync: generateDocxFn,
  } = useMutation({
    mutationFn: generateDocx,
    onError: (error) => {
      const message = error?.message;

      toast({
        variant: "error",
        title: t`Oops, the server returned an error.`,
        description: message,
      });
    },
  });

  return { generateDocx: generateDocxFn, loading, error };
};
